"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("../../utils");

require("./FormGroup.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function FormGroup(_ref) {
  var focused = _ref.focused,
      opened = _ref.opened,
      disabled = _ref.disabled,
      error = _ref.error,
      children = _ref.children;
  var formGroupClassName = (0, _utils.getClassNames)('form-group', {
    'form-group_focused': focused
  }, {
    'form-group_opened': opened
  }, {
    'form-group_disabled': disabled
  }, {
    'form-group_invalid': error
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: formGroupClassName
  }, children);
}

FormGroup.propTypes = {
  disabled: _propTypes.default.bool,
  focused: _propTypes.default.bool,
  opened: _propTypes.default.bool,
  error: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),
  children: _propTypes.default.node
};
FormGroup.defaultProps = {
  disabled: false,
  focused: false,
  opened: false,
  error: false,
  children: null
};
var _default = FormGroup;
exports.default = _default;